import React from "react"
import { Link } from "react-router-dom"
import DynamicImage from "../common/DynamicImage"
import { HighlightText } from "../common/HighlightText"

const ProjectStartArea = ({ data }) => {
  return (
    <>
      <div className="project-start-area ptb-70 about-project-area" data-aos="fade-up" data-aos-duration="1200">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6 col-md-12 order-2 order-lg-1">
              <div className="project-start-image">
                <DynamicImage image={data.image} />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 order-1 order-lg-2">
              <div className="project-start-content text-start">
                {data.title && <h2><HighlightText content={data.title} /></h2>}
                {data?.description?.map((block, index) => {
                if (block.type === "paragraph") {
                  return (
                    <p key={index}>
                      {block.children.map((c) => c.text).join("")}
                    </p>
                  );
                }
                return null;
              })}
              </div>
              {(data?.quoteText || data?.quoteHeading) && (
              <div className="partner-quote">
                {data?.quoteText && <p className="mb-0">{data.quoteText}</p>}
                {data?.quoteHeading && <h6>{data.quoteHeading}</h6>}
              </div>
            )}

              {data?.secButton && (
              <Link to={data.secButton.url} className="default-btn">
                <i className="bx bx-support"></i>
                {data.secButton.label}
              </Link>
            )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProjectStartArea
